"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReportingFilterComponent_1;
const core_1 = require("@angular/core");
const idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_filtering_controls_1 = require("@synisys/idm-filtering-controls");
const idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
const idm_me_client_js_1 = require("@synisys/idm-me-client-js");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_um_client_js_1 = require("@synisys/idm-um-client-js");
require("rxjs/add/operator/debounceTime");
const reporting_category_value_loader_1 = require("./loader/reporting-category-value-loader");
let ReportingFilterComponent = ReportingFilterComponent_1 = class ReportingFilterComponent {
    constructor(pathService, userService, classifierService, currentLanguageProvider, authenticationService, messageService, kbService, meCategoriesCommonService) {
        this.pathService = pathService;
        this.userService = userService;
        this.classifierService = classifierService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.authenticationService = authenticationService;
        this.messageService = messageService;
        this.kbService = kbService;
        this.meCategoriesCommonService = meCategoriesCommonService;
        this._isValid = null;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(classifierService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(messageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(kbService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(authenticationService);
        this.datasetID = null;
        this.filterTreeDTO = null;
        this.filterTreeDTOChange = new core_1.EventEmitter();
        this._isValidChange = new core_1.EventEmitter();
        this.filterTreeDTOEmitted = null;
    }
    ngOnChanges(changes) {
        let datasetIdChange = changes["datasetID"];
        let filterTreeDtoChange = changes["filterTreeDTO"];
        if (this.datasetID === null || this.datasetID === undefined) {
            throw new Error("Value of input property 'datasetID' is mandatory.");
        }
        if (datasetIdChange && !filterTreeDtoChange) {
            this.filterTreeDTO = null;
            this.filterTreeDTOEmitted = null;
        }
        if (datasetIdChange && !datasetIdChange.isFirstChange()) {
            this.resetState();
        }
        else if (filterTreeDtoChange && !filterTreeDtoChange.isFirstChange()
            && (this.filterTreeDTO === null || this.filterTreeDTOEmitted === null ||
                this.filterTreeDTO.toJson() !== this.filterTreeDTOEmitted.toJson())) {
            this.resetState();
        }
    }
    ngOnInit() {
        this.resetState();
    }
    ngOnDestroy() {
        this.clearState();
    }
    get commonFilterTreeDto() {
        return this._commonFilterTreeDto;
    }
    set commonFilterTreeDto(filterTreeDto) {
        this._commonFilterTreeDto = filterTreeDto;
        let commonFilterTreeJson = filterTreeDto.toJson();
        let reportingFilterTreeJson = commonFilterTreeJson
            .replace(new RegExp('itemId', 'g'), 'pathHolderId')
            .replace(new RegExp('onCategoryItemId', 'g'), 'onCategoryPathHolderId')
            .replace(new RegExp('byCategoryItemId', 'g'), 'byCategoryPathHolderId')
            .replace(new RegExp('onMeasureItemId', 'g'), 'onMeasurePathHolderId')
            .replace(new RegExp('byMeasureItemId', 'g'), 'byMeasurePathHolderId');
        this.filterTreeDTO = idm_reporting_service_client_js_1.FilterTreeDto.fromJson(reportingFilterTreeJson);
        this.filterTreeDTOEmitted = this.filterTreeDTO;
        this.filterTreeDTOChange.emit(this.filterTreeDTO);
    }
    get commonFilterModel() {
        return this._commonFilterModel;
    }
    get valueLoader() {
        return this._valueLoader;
    }
    get isValid() {
        return this._isValid;
    }
    set isValid(isValid) {
        this._isValid = isValid;
        this._isValidChange.emit(this._isValid);
    }
    clearState() {
        this._commonFilterModel = undefined;
        this._commonFilterTreeDto = undefined;
    }
    resetState() {
        this.clearState();
        if (this.datasetID) {
            Promise.all([this.loadPaths(), this.loadPathGroups(), this.loadMetaCategories()])
                .then(([paths, groups, metaCategories]) => {
                this._commonFilterModel = ReportingFilterComponent_1.constructCommonFilterModel(paths, groups, metaCategories);
                this._valueLoader = new reporting_category_value_loader_1.ReportingCategoryValueLoader(this.classifierService, this.userService, this.authenticationService, this.meCategoriesCommonService, this.currentLanguageProvider, paths);
            })
                .catch((err) => {
                this.clearState();
                console.error("Failed with the following error: %o", err);
            });
        }
        if (this.filterTreeDTO) {
            this._commonFilterTreeDto = ReportingFilterComponent_1.constructCommonFilterTreeDto(this.filterTreeDTO);
        }
    }
    loadPaths() {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(this.datasetID);
        return this.pathService.getPaths(this.datasetID)
            .then((paths) => {
            let availablePaths = new Map();
            ReportingFilterComponent_1.extractAvailablePaths(paths.categoryPaths, availablePaths);
            ReportingFilterComponent_1.extractAvailablePaths(paths.measurePaths, availablePaths);
            return availablePaths;
        })
            .catch((err) => {
            console.error("Failed with the following error: %o", err);
            return Promise.reject(err);
        });
    }
    loadPathGroups() {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(this.datasetID);
        return this.pathService.getPathGroups(this.datasetID)
            .then((groups) => {
            groups.forEach((group) => {
                group.paths.sort((path1, path2) => {
                    return path1.sortId - path2.sortId;
                });
            });
            return groups;
        })
            .catch((err) => {
            console.error("Failed with the following error: %o", err);
            return Promise.reject(err);
        });
    }
    loadMetaCategories() {
        return this.kbService.getAllMetaCategories('reporting')
            .map(metaCategories => {
            const map = new Map();
            metaCategories.forEach(metaCategory => {
                map.set(metaCategory.getSystemName(), metaCategory);
            });
            return map;
        })
            .first().toPromise()
            .catch((err) => {
            console.error("Failed with the following error: %o", err);
            return Promise.reject(err);
        });
    }
    static constructCommonFilterModel(paths, groups, metaCategories) {
        const categoryItems = new Map();
        const measureItems = new Map();
        paths.forEach((path, pathId) => {
            if (path instanceof idm_dataset_service_client_js_1.CategoryPathDto) {
                let metaCategory = metaCategories.get(path.metaCategoryId.systemName);
                let categoryItemDto;
                let categoryType = ReportingFilterComponent_1.categoryTypesMap.get(path.categoryType);
                let dateCategoryType = ReportingFilterComponent_1.dateCategoryTypesMap.get(path.dateCategoryType);
                if (!metaCategory) {
                    throw new Error(`MetaCategory of ${path} is wrong and does not exist in KB or exists with different name`);
                }
                if (categoryType === idm_filtering_controls_1.CategoryType.STANDARD && metaCategory.getSystemName() === ReportingFilterComponent_1.USER_CATEGORY_SYSTEM_NAME) {
                    categoryType = idm_filtering_controls_1.CategoryType.USER;
                }
                if (metaCategory.getIsWithVersioning()) {
                    categoryItemDto = new idm_filtering_controls_1.CategoryItemDto(pathId, path.name, categoryType, dateCategoryType, metaCategory.getIsWithVersioning(), metaCategory.getSystemName(), metaCategory.getNameMetaFieldIds().map(metaField => metaField.getSystemName()));
                }
                else if (path.pathSource !== idm_dataset_service_client_js_1.PathSource.INDICATORS) {
                    categoryItemDto = new idm_filtering_controls_1.CategoryItemDto(pathId, path.name, categoryType, dateCategoryType, false, null, metaCategory.getNameMetaFieldIds().map(metaField => metaField.getSystemName()), metaCategory.getIsCacheable());
                }
                else if (path.pathSource == idm_dataset_service_client_js_1.PathSource.INDICATORS) {
                    categoryItemDto = new idm_filtering_controls_1.CategoryItemDto(pathId, path.name, categoryType, dateCategoryType, null, metaCategory.getSystemName(), metaCategory.getNameMetaFieldIds().map(metaField => metaField.getSystemName()));
                }
                else {
                    categoryItemDto = new idm_filtering_controls_1.CategoryItemDto(pathId, path.name, categoryType, dateCategoryType);
                }
                categoryItems.set(pathId, categoryItemDto);
            }
            else if (path instanceof idm_dataset_service_client_js_1.MeasurePathDto) {
                measureItems.set(pathId, new idm_filtering_controls_1.MeasureItemDto(pathId, path.name, ReportingFilterComponent_1.measureTypesMap.get(path.measurePathType)));
            }
        });
        let itemGroupDtos = groups.map(pathGroupDto => {
            return new idm_filtering_controls_1.ItemGroupDto(pathGroupDto.id, pathGroupDto.name, pathGroupDto.paths.map(orderedPathDto => {
                return new idm_filtering_controls_1.OrderedItemDto(orderedPathDto.pathId, orderedPathDto.sortId);
            }));
        });
        return new idm_filtering_controls_1.Model(new idm_filtering_controls_1.ItemsDto(categoryItems, measureItems), itemGroupDtos);
    }
    static constructCommonFilterTreeDto(filterTreeDto) {
        let reportingFilterTreeJson = filterTreeDto.toJson();
        let commonFilterTreeJson = reportingFilterTreeJson
            .replace(new RegExp('pathHolderId', 'g'), 'itemId')
            .replace(new RegExp('onCategoryPathHolderId', 'g'), 'onCategoryItemId')
            .replace(new RegExp('byCategoryPathHolderId', 'g'), 'byCategoryItemId')
            .replace(new RegExp('onMeasurePathHolderId', 'g'), 'onMeasureItemId')
            .replace(new RegExp('byMeasurePathHolderId', 'g'), 'byMeasureItemId');
        return idm_filtering_controls_1.FilterTreeDto.fromJson(commonFilterTreeJson);
    }
    static extractAvailablePaths(source, target) {
        source.forEach((path) => {
            if (ReportingFilterComponent_1.isAvailablePath(path)) {
                target.set(path.id, path);
            }
        });
    }
    static isAvailablePath(path) {
        if (path.appearanceType != idm_dataset_service_client_js_1.AppearanceType.EVERYWHERE && path.appearanceType != idm_dataset_service_client_js_1.AppearanceType.FILTERS) {
            return false;
        }
        return !(path instanceof idm_dataset_service_client_js_1.CategoryPathDto &&
            path.categoryType != idm_dataset_service_client_js_1.CategoryType.STANDARD &&
            path.categoryType != idm_dataset_service_client_js_1.CategoryType.DATE &&
            path.categoryType != idm_dataset_service_client_js_1.CategoryType.ME_ASSETS);
    }
};
ReportingFilterComponent.categoryTypesMap = new Map([
    [idm_dataset_service_client_js_1.CategoryType.DATE, idm_filtering_controls_1.CategoryType.DATE],
    [idm_dataset_service_client_js_1.CategoryType.CURRENCY, idm_filtering_controls_1.CategoryType.CURRENCY],
    [idm_dataset_service_client_js_1.CategoryType.DOCUMENT, idm_filtering_controls_1.CategoryType.DOCUMENT],
    [idm_dataset_service_client_js_1.CategoryType.INDICATOR, idm_filtering_controls_1.CategoryType.STANDARD],
    [idm_dataset_service_client_js_1.CategoryType.STANDARD, idm_filtering_controls_1.CategoryType.STANDARD],
    [idm_dataset_service_client_js_1.CategoryType.ME_ASSETS, idm_filtering_controls_1.CategoryType.ME_ASSETS],
    [idm_dataset_service_client_js_1.CategoryType.DISAGGREGATION, idm_filtering_controls_1.CategoryType.ME_ASSETS],
    [idm_dataset_service_client_js_1.CategoryType.FRAMEWORK, idm_filtering_controls_1.CategoryType.ME_ASSETS]
]);
ReportingFilterComponent.dateCategoryTypesMap = new Map([
    [idm_dataset_service_client_js_1.DateCategoryType.YEAR, idm_filtering_controls_1.DateCategoryType.YEAR],
    [idm_dataset_service_client_js_1.DateCategoryType.SEMI_ANNUAL, idm_filtering_controls_1.DateCategoryType.SEMI_ANNUAL],
    [idm_dataset_service_client_js_1.DateCategoryType.QUARTER, idm_filtering_controls_1.DateCategoryType.QUARTER],
    [idm_dataset_service_client_js_1.DateCategoryType.MONTH, idm_filtering_controls_1.DateCategoryType.MONTH],
    [idm_dataset_service_client_js_1.DateCategoryType.WEEK, idm_filtering_controls_1.DateCategoryType.WEEK],
    [idm_dataset_service_client_js_1.DateCategoryType.DAY, idm_filtering_controls_1.DateCategoryType.DAY]
]);
ReportingFilterComponent.measureTypesMap = new Map([
    [idm_dataset_service_client_js_1.MeasurePathType.BOOLEAN, idm_filtering_controls_1.MeasureType.BOOLEAN],
    [idm_dataset_service_client_js_1.MeasurePathType.DATE, idm_filtering_controls_1.MeasureType.DATE],
    [idm_dataset_service_client_js_1.MeasurePathType.DATETIME, idm_filtering_controls_1.MeasureType.DATE],
    [idm_dataset_service_client_js_1.MeasurePathType.MONEY, idm_filtering_controls_1.MeasureType.MONEY],
    [idm_dataset_service_client_js_1.MeasurePathType.NUMBER, idm_filtering_controls_1.MeasureType.NUMBER],
    [idm_dataset_service_client_js_1.MeasurePathType.TEXT, idm_filtering_controls_1.MeasureType.TEXT],
]);
ReportingFilterComponent.USER_CATEGORY_SYSTEM_NAME = 'User';
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ReportingFilterComponent.prototype, "datasetID", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_reporting_service_client_js_1.FilterTreeDto)
], ReportingFilterComponent.prototype, "filterTreeDTO", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ReportingFilterComponent.prototype, "filterTreeDTOChange", void 0);
__decorate([
    core_1.Output("validityChange"),
    __metadata("design:type", core_1.EventEmitter)
], ReportingFilterComponent.prototype, "_isValidChange", void 0);
ReportingFilterComponent = ReportingFilterComponent_1 = __decorate([
    core_1.Component({
        
        selector: "sis-reporting-filter",
        template: require('./reporting-filter.component.html')
    }),
    __metadata("design:paramtypes", [idm_dataset_service_client_js_1.PathService, idm_um_client_js_1.UserService,
        idm_classifier_service_client_js_1.ClassifierService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_authentication_client_js_1.AuthenticationService,
        idm_message_language_service_client_js_1.MessageService, idm_kb_service_client_js_1.KbService,
        idm_me_client_js_1.CommonServicesProviderService])
], ReportingFilterComponent);
exports.ReportingFilterComponent = ReportingFilterComponent;
//# sourceMappingURL=reporting-filter.component.js.map